/* eslint-disable import/prefer-default-export */

import { AssetsView } from '../../lib/constants'

export type AssetViewOption = {
  value: AssetsView
  label: string
}

export const assetViewOptions: AssetViewOption[] = [
  {
    value: AssetsView.CARD,
    label: 'Card',
  },
  {
    value: AssetsView.LIST,
    label: 'List',
  },
]
